import { take, takeLatest } from "redux-saga/effects";
import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import { createCourse, deleteCourse, fetchAllCourses } from "../../actions/courses";
import { fetchAllScormPackages } from "../../actions/scormPackages";

const Creators = (AllCreators as any).App.Courses;
const Types = (AllTypes as any)._APP._COURSES;

export function* watchFetchAllScormPackages() {
  yield takeLatest(
    Types.FETCH_ALL_SCORM_PACKAGES,
    fetchAllScormPackages({
      onFailure: Creators.handleFetchAllScormPackagesFailure,
      onSuccess: Creators.handleFetchAllScormPackagesSuccess,
    })
  );
}

export function* watchFetchAllCourses() {
  yield takeLatest(
    Types.FETCH_ALL_COURSES,
    fetchAllCourses({
      onFailure: Creators.handleFetchAllCoursesFailure,
      onSuccess: Creators.handleFetchAllCoursesSuccess,
    })
  );
}

export function* watchCreateCourse() {
  yield takeLatest(
    Types.CREATE_COURSE,
    createCourse({
      onFailure: Creators.handleCreateCourseFailure,
      onSuccess: Creators.handleCreateCourseSuccess,
    })
  );
}

export function* watchDeleteCourse() {
  yield takeLatest(
    Types.DELETE_COURSE,
    deleteCourse({
      onFailure: Creators.handleDeleteCourseFailure,
      onSuccess: Creators.handleDeleteCourseSuccess,
    })
  );
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
